import React from 'react';

const styles = {
  container: {
    padding: '40px 10%',
    lineHeight: '1.7',
    color: '#333',
    fontFamily: 'Arial, sans-serif',
  },
  h1: {
    fontSize: '26px',
    color: 'white',
  },
  h2: {
    fontSize: '19px',
    color: '#white',
    marginTop: '40px',
    borderBottom: '1px solid #eee',
    paddingBottom: '10px',
  },
  p: {
    color: '#595959',
    fontSize: '14px',
  },
  strong: {
    color: '#white',
  },
  a: {
    color: 'orange',
  },
  ul: {
    listStyleType: 'square',
    paddingLeft: '20px',
  }
};

const Privacy = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.h1}>PRIVACY POLICY</h1>
      <p style={styles.p}>
        <strong>Last updated: July 18, 2025</strong>
      </p>

      <p style={styles.p}>
        This Privacy Notice for Byounguk Min ("we," "us," or "our"), describes how and why we might access, collect, store, use, and/or share your personal information when you use our services ("Services"), such as when you:
      </p>
      <ul style={styles.ul}>
        <li>
          <p style={styles.p}>Download and use our mobile application, Cafe Assist, or any other application of ours that links to this Privacy Notice.</p>
        </li>
        <li>
          <p style={styles.p}>Engage with us in other related ways, including any sales, marketing, or events.</p>
        </li>
      </ul>
      <p style={styles.p}>
        <strong style={styles.strong}>Questions or concerns?</strong> Reading this Privacy Notice will help you understand your privacy rights and choices. If you do not agree with our policies and practices, please do not use our Services. If you still have any questions or concerns, please contact us at Brandenmin.dev@gmail.com.
      </p>

      {/* --- TABLE OF CONTENTS --- */}
      <h2 style={styles.h2} id="toc">TABLE OF CONTENTS</h2>
      <ol>
        <li><a href="#infocollect" style={styles.a}>WHAT INFORMATION DO WE COLLECT?</a></li>
        <li><a href="#infouse" style={styles.a}>HOW DO WE PROCESS YOUR INFORMATION?</a></li>
        <li><a href="#legalbases" style={styles.a}>WHAT LEGAL BASES DO WE RELY ON?</a></li>
        <li><a href="#whoshare" style={styles.a}>WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</a></li>
        <li><a href="#inforetain" style={styles.a}>HOW LONG DO WE KEEP YOUR INFORMATION?</a></li>
        <li><a href="#infosafe" style={styles.a}>HOW DO WE KEEP YOUR INFORMATION SAFE?</a></li>
        <li><a href="#infominors" style={styles.a}>DO WE COLLECT INFORMATION FROM MINORS?</a></li>
        <li><a href="#privacyrights" style={styles.a}>WHAT ARE YOUR PRIVACY RIGHTS?</a></li>
        <li><a href="#policyupdates" style={styles.a}>DO WE MAKE UPDATES TO THIS NOTICE?</a></li>
        <li><a href="#contact" style={styles.a}>HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</a></li>
      </ol>

      {/* --- SECTION 1 --- */}
      <h2 style={styles.h2} id="infocollect">1. WHAT INFORMATION DO WE COLLECT?</h2>
      <p style={styles.p}>
        <strong style={styles.strong}>In Short:</strong> We do not collect any personal information. Your data is your own.
      </p>
      <p style={styles.p}>
        We do not require you to register an account or provide any personal information to use our Services. All data related to shelf life management is stored locally on your device and is not transmitted to us.
      </p>

      {/* --- SECTION 2 --- */}
      <h2 style={styles.h2} id="infouse">2. HOW DO WE PROCESS YOUR INFORMATION?</h2>
      <p style={styles.p}>
        <strong style={styles.strong}>In Short:</strong> We do not process your information as we do not collect it.
      </p>
      <p style={styles.p}>
        We do not process, access, or see any of the data you input into the Cafe Assist application.
      </p>

      {/* --- SECTION 3 --- */}
      <h2 style={styles.h2} id="legalbases">3. WHAT LEGAL BASES DO WE RELY ON?</h2>
      <p style={styles.p}>
        <strong style={styles.strong}>In Short:</strong> We process your information based on your consent to use our app and our legitimate business interests.
      </p>
      <p style={styles.p}>
        As we are based in Canada, we process information where permission can be inferred (implied consent) by your use of the app. Since we do not collect personal data, our processing is limited to non-identifiable, aggregated analytics for service improvement, which serves our legitimate business interests.
      </p>
      
      {/* --- SECTION 4 --- */}
      <h2 style={styles.h2} id="whoshare">4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</h2>
      <p style={styles.p}>
        <strong style={styles.strong}>In Short:</strong> We do not share your personal information with any third parties.
      </p>
      
      {/* --- SECTION 5 --- */}
      <h2 style={styles.h2} id="inforetain">5. HOW LONG DO WE KEEP YOUR INFORMATION?</h2>
      <p style={styles.p}>
        <strong style={styles.strong}>In Short:</strong> We do not keep your information.
      </p>
      <p style={styles.p}>
        All data is stored on your device and can be deleted by you at any time by uninstalling the application.
      </p>

      {/* --- SECTION 6 --- */}
      <h2 style={styles.h2} id="infosafe">6. HOW DO WE KEEP YOUR INFORMATION SAFE?</h2>
      <p style={styles.p}>
        <strong style={styles.strong}>In Short:</strong> Your information is kept safe on your device, under your control.
      </p>
      <p style={styles.p}>
        We have implemented security measures by design, as the app operates offline and does not transmit your data over the internet. The security of your data on your device is subject to your device's security features.
      </p>

      {/* --- SECTION 7 --- */}
      <h2 style={styles.h2} id="infominors">7. DO WE COLLECT INFORMATION FROM MINORS?</h2>
      <p style={styles.p}>
        <strong style={styles.strong}>In Short:</strong> We do not knowingly collect data from or market to children under 18 years of age.
      </p>
      <p style={styles.p}>
        By using the Services, you represent that you are at least 18 or that you are the parent or guardian of such a minor and consent to the minor’s use of the Services.
      </p>

      {/* --- SECTION 8 --- */}
      <h2 style={styles.h2} id="privacyrights">8. WHAT ARE YOUR PRIVACY RIGHTS?</h2>
      <p style={styles.p}>
        <strong style={styles.strong}>In Short:</strong> Since we do not collect your data, most data rights are not applicable. You have the right to delete the app and all its data at any time.
      </p>
      <p style={styles.p}>
        In some regions, like Canada, you have rights that allow you greater access to and control over your personal information. However, since we collect no personal information, these rights such as access, rectification, or erasure of centrally stored data do not apply. You can exercise your ultimate right by deleting the app from your device.
      </p>

      {/* --- SECTION 9 --- */}
      <h2 style={styles.h2} id="policyupdates">9. DO WE MAKE UPDATES TO THIS NOTICE?</h2>
      <p style={styles.p}>
        <strong style={styles.strong}>In Short:</strong> Yes, we will update this notice as necessary to stay compliant with relevant laws.
      </p>
      <p style={styles.p}>
        We may update this Privacy Notice from time to time. The updated version will be indicated by an updated "Last updated" date.
      </p>

      {/* --- SECTION 10 --- */}
      <h2 style={styles.h2} id="contact">10. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</h2>
      <p style={styles.p}>
        If you have questions or comments about this notice, you may email us at Brandenmin.dev@gmail.com.
      </p>
    </div>
  );
};

export default Privacy;